import { Component, Directive, NgModule, VERSION, Input, AfterViewInit, OnInit, OnChanges, SimpleChange, ElementRef, TemplateRef, ViewContainerRef, OnDestroy, Renderer2 } from '@angular/core'
import { Validators, FormsModule, ReactiveFormsModule, FormBuilder, NgForm, FormGroup, AbstractControl, FormControl, ControlContainer, FormGroupDirective } from '@angular/forms';
import { Observable, Subscription } from 'rxjs';
import * as _ from 'lodash';

interface ServerErrorMessage {
  field: string;
  message: string;
}

const VALIDATION_MESSAGES = {
  required: `This field <strong>required</strong>.`,
  minlength: `Please add more characters.`,
  maxlength: `Maximum character excited.`,
  pattern: `Pattern not match.`
};
@Component({
  selector: 'app-field-error-message',
  templateUrl: './field-error-message.component.html',
  styleUrls: ['./field-error-message.component.scss']
})
export class FieldErrorMessageComponent implements OnInit, OnChanges {

  @Input() formControlN: string;  // formControlName
  @Input(`err.list`)
  set errList(_val) {
    this.err.list = _val
  }
  get errList() {
    return this.err.list;
  }

  err: { list: Array<ServerErrorMessage> } = { list: [] };
  canNgMessageShow: boolean = false;
  control: AbstractControl;
  hasView = false;
  controlValue$: Observable<any>;
  controlSubscription: Subscription;
  hasSubmitted: boolean;
  customErrors: Array<ServerErrorMessage> = [];
  messages: Array<string>;

  constructor(
    private _fg: ControlContainer,
    private _el: ElementRef,
    private render: Renderer2
  ) { }

  ngOnChanges(changes: { [propKey: string]: SimpleChange }) {
    if (changes['errList'] && !_.isEqual(changes['errList'].previousValue, changes['errList'].currentValue)) {
      this.customErrors = <ServerErrorMessage[]>_.filter(changes['errList'].currentValue, { field: this.formControlN })
      this.setVisible();
    }
  }

  ngOnInit() {
    this.control = this.form.get(this.formControlN);
    let formSubmit$ = (<FormGroupDirective>this._fg).ngSubmit.map(() => {
      this.hasSubmitted = true;
    });
    this.controlValue$ = Observable.merge(this.control.valueChanges, Observable.of(''), formSubmit$);
    this.controlSubscription = this.controlValue$.subscribe(() => {
      this.setVisible();
    });
  }

  private setVisible() {
    this.formatMessages();
    if (this.isControlInvalid() || this.haveCustomError()) {
      this.render.removeStyle(this._el.nativeElement, 'display');

      // this.control.setValidators(Validators.pattern("^\s*$"));
      // this.control.updateValueAndValidity();
      // console.log('existing validator > ', this.control.validator);
    } else {
      this.render.setStyle(this._el.nativeElement, 'display', 'none');
    }
  }

  isControlInvalid() {
    return this.control && this.control.invalid && (this.control.dirty || this.hasSubmitted);
  }

  haveCustomError() {
    return this.customErrors.length > 0;
  }

  formatMessages() {
    this.messages = [];

    // push angular validations to message list
    if (this.canNgMessageShow && this.control && this.control.errors) {
      let errorKeys = Object.keys(this.control.errors);
      errorKeys.map((item) => { this.messages.push(this.getNgMessage(item)) });
    }

    // push server errors to message list
    if (this.customErrors && this.customErrors.length > 0) {
      this.customErrors.map((item) => { this.messages.push(item.message) });
    }
  }

  getNgMessage(_key: string): string {
    return VALIDATION_MESSAGES[_key] || _key;
  }

  get form() { return this._fg.formDirective ? (this._fg.formDirective as FormGroupDirective).form : null; }

  ngOnDestroy() {
    this.controlSubscription.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/shared/components/field-error-message/field-error-message.component.ts